import { ReactElement } from 'react'
import UserForm from '../../forms/user-form'

export const RegisterScreen = (): ReactElement => {
  return (
    <div>
      Login screen You have to login first
      <UserForm />
    </div>
  )
}